import React from 'react';

const SearchPage = () => (
  <section className="search">
    <div id="faceteddata">
      <span>Filter results by</span>
    </div>
    <div id="resultdata" />
  </section>
);

export default SearchPage;
